/**
 * @desc 车辆等级报告标签组建
 * @props
 *        is268V [可选传] 是否是268V检测报告 是展示该标签 否不展示 默认是
 *        rank 等级
 *        style [可选传] style
 *        className [可选传] className
 *        isAuctioneer [可选传] isAuctioneer 体现在样式上大小等，可以通过style和className自行调节样式
 * @argument 该标签默认展示在父元素的右下角，使用的时候，需要将父元素加上postion:relative，可以通过style和className自行调节样式
 */
import React from 'react';
import styled from 'styled-components';
const Root = styled.div `
  position: absolute;
  padding: ${(props) => props.isAuctioneer ? '0.06rem 0.1rem 0 0.14rem' : '0.07rem 0.15rem 0 0.2rem'};
  right: 0;
  bottom: 0;
  z-index: 11;
  color: #000;
  font-size: ${(props) => props.isAuctioneer ? '0.2rem' : '0.32rem'};
  &::before{
    content: '';
    position: absolute;
    top:0;left:0;right:0;bottom:1px;
    z-index: -1;
    background-image: linear-gradient(137deg, #ffd910 0%, #ffb811 100%);
    transform: perspective(.5em) rotateX(2deg);
    transform-origin: bottom right;
  }
`;
export default function CarLevel(props) {
    const { is268V = true, rank, style, className, isAuctioneer } = props;
    return is268V && rank ? (<Root style={style} className={className} isAuctioneer={isAuctioneer}>{rank}</Root>) : null;
}
